import { forwardRef, TextareaHTMLAttributes } from 'react';

type TextareaProps = {
    className?: string;
    inputClassName?: string;
    // icon?: React.ReactNode;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className = '', inputClassName = '', /* icon, */ ...rest }, ref) => {
    return (
        <div className={'flex items-center rounded-[4px] bg-midnight text-ash-grey p-[8px] ' + className}>
            {/* <div className='shrink-0'>{icon}</div> */}
            <textarea ref={ref} className={'shrink-1 h-full min-w-0 w-full bg-transparent ' + inputClassName} {...rest} />
        </div>
    );
});

Textarea.displayName = 'Textarea';
